// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"officeCompany_wrapper__1wWkj","button":"officeCompany_button__3wnUZ"};